import React, {Component} from 'react';
import Tooltip from 'components/atoms/tooltip';

class InputCheckbox extends Component {
    constructor(props) {
        super(props);
        this.state = {checked: props.checked};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {checked} = this.props;
        if (prevState.checked !== checked) {
            this.setState({checked});
        }
    }

    onChange(isChecked) {
        this.props.onChange(isChecked);
    }

    render() {
        const {className = '', value, label, inline, size, tooltip} = this.props;
        const basicClass = inline ? 'checkbox-inline' : 'checkbox';
        const sizeClass = size === 'md' ? 'md-label' : '';

        return (
            <div className={`${basicClass} ${className} ${sizeClass}`}>
                <label>
                    <input
                        type="checkbox"
                        value={value}
                        checked={this.state.checked}
                        onChange={((e) => this.onChange(e.target.checked)).bind(this)}
                    />
                    {label}
                </label>
                {tooltip && <Tooltip subject={tooltip} />}
            </div>
        );
    }
}

export default InputCheckbox;
